<template>
  <form id="frm_action">
    <div class="p-formgrid">

      <Toolbar class="fixed-bottom-toolbar div-button css-button-top-right">
        <template slot="right">
          <Button
              label="Back"
              @click="backToList()"
              id="back"
              class="main-style-button"
          />
        </template>
      </Toolbar>


      <div class="col-6">
        <!--        <div class="p-card-field">
                  <label class="p-col-fixed txt-right txt-required">Property</label>
                  <div class="p-col">
                    <v-select :clearable="false" title="Property" class="" @search="SearchProperty" placeholder="Choose" v-model="obj_data.property_id" :options="listProperty" :reduce="property_item => property_item.id" label="name"  >
                      <span slot="no-options" @click="$refs.select.open = false">
                        Empty data
                      </span>
                    </v-select>
                    <input class="input_tmp_validator" id="property">
                  </div>
                </div>-->

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Fullname</label>
          <div class="p-col">
            <InputText maxlength="50" id="name" type="text" class="" v-model="obj_data.fullname"  placeholder="Input"/>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Email</label>
          <div class="p-col">
            <InputText maxlength="50" id="email" type="text" class="" v-model="obj_data.email"  placeholder="Input"/>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Phone number</label>
          <div class="p-col ">
            <div class="style-box-phone">
              <input class="input_tmp_validator" id="prefix_phone">
              <Dropdown  v-model="obj_data.prefix_phone" :options="list_phone_code" optionLabel="label" optionValue="value"/>
              <InputText type="number" id="phone" class="" v-model="obj_data.phone"  placeholder="Input"/>
            </div>
          </div>
        </div>
<!--        <div class="p-card-field">
          <div class="row">
            <div class="col-6">
              <label class="p-col-fixed txt-right txt-required">Available for use from</label>
              <div class="p-col">
                <Calendar
                    :showOnFocus="false"
                    dateFormat="MM dd, yy"
                    :showIcon="true"
                    appendTo="body"
                    :showClear="true"
                    :manualInput="false"
                    v-model="obj_data.available_from" placeholder="Choose"
                />
                <input class="input_tmp_validator" id="available_from"/>
              </div>
            </div>

            <div class="col-6">
              <label class="p-col-fixed txt-right">To</label>
              <div class="p-col">
                <Calendar
                    :showOnFocus="false"
                    dateFormat="MM dd, yy"
                    id="end_booking_date"
                    :showIcon="true"
                    appendTo="body"
                    :showClear="true"
                    :manualInput="false"
                    v-model="obj_data.available_to"
                    placeholder="Choose"
                />
                <input class="input_tmp_validator" id="available_to"/>
              </div>
            </div>
          </div>
        </div>-->

        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Password</label>
          <div class="p-col">
            <div class="box-password-style" >
              <InputText maxlength="255" id="password" :type="passwordType" class="" v-model="obj_data.password"
                         placeholder="Input" />
              <i  v-if="passwordType === 'text'" class="material-icons lg-icon-password" @click="switchVisibility">visibility</i>
              <i  v-else class="material-icons lg-icon-password" @click="switchVisibility">visibility_off</i>
            </div>
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt-required">Re-enter password</label>
          <div class="p-col">
            <div class="box-password-style" >
              <InputText maxlength="255" id="Re_enter_password" :type="passwordReType" class="" v-model="obj_data.re_password"
                         placeholder="Input" />
              <i  v-if="passwordReType === 'text'" class="material-icons lg-icon-password" @click="switchVisibility($event,'re')">visibility</i>
              <i  v-else class="material-icons lg-icon-password" @click="switchVisibility($event,'re')">visibility_off</i>
            </div>
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Avatar</label>
          <div class="p-col">
            <div class="cus-text">Recommend: 500x500px  Maximum:10 MB</div>
            <div class="cus-text">Accepted file:JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component"  accept="image/*" name="images[]" id="images_service" type="file" @change="onFileSelectFile"/><!--@change="onFileSelectLogo"-->
            <input class="input_tmp_validator" id="list_file">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file" :key="index">
                <img class="style_img" :src="item.objectURL"/>
                <div class="button-clear" @click="onFileClear(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
              <!--              <span :key="comFilename">{{ obj_data.filename }}</span>-->
            </div>

            <!--            <div class="select-button" style="background-color: rgb(227, 237, 252);height: max-content;text-align: justify;justify-items: center;display: flex;padding: 0.55rem;margin: -0.429rem;">
              <span style="margin: auto;">Tải lên</span>
            </div>-->
          </div>
        </div>
      </div>
      <div class="col-12" v-if="mode=='edit'">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right style_title_group ">PROPERTY LIST</label>
<!--          <div class="p-col">
          </div>-->
        </div>
        <div class="p-card-field">
          <div class="p-col">
            <BaseDatatable
                v-if="dataModelProperty"
                :key="componentKeyProperty"
                :tableData="listDataProperty"
                :model="dataModelProperty"
            ></BaseDatatable>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right style_title_group ">OTHER INFORMATION</label>
<!--          <div class="p-col">
          </div>-->
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right ">Bank account</label>
          <div class="p-col">
            <InputText maxlength="50" id="bank_account" type="text" class="" v-model="obj_data.bank_account"  placeholder="Input"/>
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right">Personal address</label>
          <div class="p-col">
            <Textarea id="address"  maxLength="500" rows="1" cols="30" :autoResize="true" v-model="obj_data.address" placeholder="Input" />
<!--            <InputText id="address" type="text" class="" v-model="obj_data.address"  placeholder="Input"/>-->
          </div>
        </div>

        <div class="p-card-field">
          <label class="p-col-fixed txt-right ">Note</label>
          <div class="p-col">
            <Textarea id="note"  maxLength="500" rows="1" cols="30" :autoResize="true" v-model="obj_data.note" placeholder="Input" />
<!--            <InputText id="note" type="text" class="" v-model="obj_data.note"  placeholder="Input"/>-->
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-card-field">
          <label class="p-col-fixed txt-right style_title_group ">FAMILY</label>
<!--          <div class="p-col">
          </div>-->
        </div>
        <div class="p-card-field">
          <div class="p-col">
            <BaseDatatableUserFamily
                v-if="dataModelUserFamily"
                :key="componentKeyUserFamily"
                :tableData="listDataUserFamily"
                :model="dataModelUserFamily"
                :actions="getRowActions()"
                v-on:action-click="onActionClicked"
            ></BaseDatatableUserFamily>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox  v-model="obj_data.active"  :binary="true"/>
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button
              :label="$constants.TEXT_BUTTON.BACK"
              @click="backToList()"
              class="p-button-outlined"
              id="back"
          />
          <Button
              v-if="mode == 'edit'"
              :label="$constants.TEXT_BUTTON.EDIT"
              @click="saveData()"
              class="main-style-button"
          />
          <Button
              v-else
              :label="$constants.TEXT_BUTTON.ADD"
              @click="saveData()"
              class="main-style-button"
          />
        </template>
      </Toolbar>


      
    </div>

    <Dialog header="Family" :visible.sync="dataFamilyDisplay" :style="{width: '50vw'}" >
      <form id="frm_action_week">
<!--        <p>Family</p>-->
        <div>

          <div class="p-card-field">
            <label class="p-col-fixed txt-right txt-required">Fullname</label>
            <div class="p-col">
              <InputText maxlength="50" id="fa_name" type="text" class="" v-model="dataFamily.name"  placeholder="Input"/>
            </div>
          </div>
          <div class="p-card-field">
            <label class="p-col-fixed txt-right ">Relationship</label>
            <div class="p-col">
              <InputText maxlength="50" id="fa_relationship" type="text" class="" v-model="dataFamily.relationship"  placeholder="Input"/>
            </div>
          </div>
          <div class="p-card-field">
            <label class="p-col-fixed txt-right ">Phone number</label>
            <div class="p-col ">
              <div class="style-box-phone">
                
                <Dropdown  v-model="dataFamily.prefix_phone" :options="list_phone_code" optionLabel="label" optionValue="value"/>
                <InputText type="number" id="fa_phone" class="" v-model="dataFamily.phone"  placeholder="Input"/>
              </div>
            </div>
          </div>
          <div class="p-card-field">
            <label class="p-col-fixed txt-right ">Email</label>
            <div class="p-col">
              <InputText maxlength="50" id="fa_email" type="text" class="" v-model="dataFamily.email"  placeholder="Input"/>
            </div>
          </div>
          <div class="p-card-field">
            <label class="p-col-fixed txt-right ">ID/ passport</label>
            <div class="p-col">
              <InputText id="fa_personal_id" type="text" class="" v-model="dataFamily.personal_id"  placeholder="Input"/>
            </div>
          </div>
          <div class="p-card-field">
            <label class="p-col-fixed txt-right ">Images</label>
            <div class="p-col">
              <div  class="cus-text">Maximum:100 MB</div>
              <div class="cus-text">Accepted file:JPG, JPEG, PNG, GIF.</div>
              <input class="p-inputtext p-component"  accept="image/*"  ref="fileInputProduct" name="images[]" id="images_service" type="file" @change="onFileSelectFileProduct" multiple/><!--@change="onFileSelectLogo"-->
              <input class="input_tmp_validator" id="list_file">
              <div class="cus-text style_list_image">
                <div class="box-image" v-for="(item_p, index_p) in list_file_product" :key="index_p">
                  <img class="style_img" :src="item_p.objectURL"/>
                  <div class="button-clear" @click="onFileClearProduct(item_p,index_p)"><img src="/assets/images/icon/cancel_black_24dp.png"/></div>
                </div>
                <!--              <span :key="comFilename">{{ obj_data.filename }}</span>-->
              </div>

              <!--            <div class="select-button" style="background-color: rgb(227, 237, 252);height: max-content;text-align: justify;justify-items: center;display: flex;padding: 0.55rem;margin: -0.429rem;">
                <span style="margin: auto;">Tải lên</span>
              </div>-->
            </div>
          </div>
        </div>

      </form>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-secondary" @click="dataFamilyDisplay = false"/>
        <Button label="Confirm" icon="pi pi-check"  @click="saveDataUserFamily" />
      </template>
    </Dialog>
    <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
      Are you want to delete this family ?
      <template #footer>

        <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
        <Button label="Confirm" @click="deleteData()" icon="pi pi-check"
                class="p-button-danger  btn-confirm-delete-dialog" />
      </template>
    </Dialog>
  </form>
</template>
<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import BaseDatatable from './list_property'
import BaseDatatableUserFamily from './list_user_family'
import Common from "../../../core/Common";
export default {
  components: {
    BaseDatatable,
    BaseDatatableUserFamily,
  },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      showDeleteDialog:false,

      list_id_file_delete :[],

      passwordType: 'password',
      passwordReType: 'password',

      file_product :null,
      list_file_product :[],
      list_id_file_delete_product :[],
      dataFamilyDisplay:false,
      componentDataFamily:1,
      dataFamily:{
        prefix_phone:"",
        prefix_phone_id: null,
      },
      dataModelUserFamily:null,
      componentKeyUserFamily:1,
      listDataUserFamily:[],


      dataModelProperty:null,
      componentKeyProperty:1,
      listDataProperty:[],
      phone_code:null,
      obj_data:{
        filename:"",
        prefix_phone:"",
        prefix_phone_id: null,
      },
      comFilename:1,
      list_phone_code: [
      
      ],
      dataBookingRound: [],
      selProperty: null,
      listProperty: [],
      listPropertyAll: [],
      listDocsCate: [],
      listDocsCateAll: [],
      from_to: null,
      address: null,
      start_booking_date: null,
      end_booking_date: null,
      partArr: [],
      time_zone_local : moment.tz.guess(true),
      componentKey: 0,
      list_file :[],
      maxFileSize: 2097152*50 , //100MB  2MB   /*104857600, // 100MB*/
    }
  },
  watch: {
    /* async "selProperty"() {
       if (!this.$commonFuction.isEmpty(this.selProperty)) {
         this.address = this.selProperty?.address;
         this.partArr = this.selProperty?.part;
         if (this.mode == 'add') {
           var arr = [];
           this.partArr.map(m => {
             arr.push({ord: m.order_booking, id: m.id});
           })
           arr.map(m=> {
             var tmp = [];
             for (let i =0; i < arr.length; i++) {
               let a = m.ord - i + arr.length;
               if (a > arr.length) {
                 a = a - arr.length;
               }
               tmp.push({ordinal: a, part_id: m.id, round: (i+1)});
             }
             this.dataBookingRound.push(tmp);
           })
         }
         this.componentKey++;
       }
     },
     "start_booking_date"() {
       if (this.partArr.length) {
         let days = 14 * this.partArr.length;
         this.end_booking_date = moment.tz(this.start_booking_date, this.time_zone_local).add(days, 'days').format("LL");
       }
     }*/
  },
  async mounted() {
    /*await this.getListProperty();
    await this.getListDocsCate();*/
    await this.getListCountry();
    console.log("this.model:",this.model)
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      this.obj_data.filename = this.model?.item_avatar?.file_name ?? ''
      if (!this.$commonFuction.isEmpty(this.model?.item_avatar)) {
        let url = this.model?.item_avatar?.url
        let obj = {'name': this.obj_data.filename, 'file': '', 'objectURL': url, type: 'old_edit'}//type:'old_edit' nếu gặp type này ko update avatar
        this.list_file.push(obj)
      }
      /*if (!this.$commonFuction.isEmpty(this.obj_data.available_from)) {
        this.obj_data.available_from = moment.tz(this.obj_data.available_from, this.time_zone_local).format("LL");
      }
      if (!this.$commonFuction.isEmpty(this.obj_data.available_to)) {
        this.obj_data.available_to = moment.tz(this.obj_data.available_to, this.time_zone_local).format("LL");
      }*/

      var where_key_part = {
        admin_property_list: {uid: {_eq: this.model.id}},
        deleted: {_eq: false}
      }
      var data_list_part = await this.$CoreService.getListUserPropertyPart(where_key_part);
      var list_part = this.$commonFuction.convertJsonObject(data_list_part.list)

      var list_convert = [];
      var stt = 0;
      for (let lp = 0; lp < list_part.length; lp++) {
        stt++;
        var itemDataLP = list_part[lp]
        var name_txt = itemDataLP?.name ?? null
        var part = itemDataLP?.part ?? [];
        var part_txt = "";
        for (let k = 0; k < part.length; k++) {
          var itemDataP = part[k];
          var uid_ = itemDataP?.uid
          if (uid_ == this.model.id){
            if (!Common.isEmpty(part_txt)){
              part_txt +=' ,';
            }
            part_txt +=itemDataP?.order_booking ?? '';
          }
        }
        itemDataLP.part_txt = part_txt;
        itemDataLP.name_txt = name_txt;
        itemDataLP.stt = stt;
        list_convert.push(itemDataLP)
      }

      var where_key = {
        type : {_eq : 2},
        uid : {_eq : this.model.id},
        // booking: {id: {_is_null: true} },
      }
      var data_list_family = await this.$CoreService.getListPeople(where_key);
      var list_family = this.$commonFuction.convertJsonObject(data_list_family.list)
      console.log("list_familylist_family:",list_family)
      var list_family_convert = [];
      for (let g = 0; g < list_family.length; g++) {
        var itemDataProduct = list_family[g];
        var list_file = itemDataProduct?.list_file ?? [];
        var list_convert_file = [];
        console.log("list_filelist_file:",list_file)
        for (let jj = 0; jj < list_file.length; jj++) {
          var itemFile = list_file[jj]
          itemFile["objectURL"] = itemFile?.url ?? null;
          itemFile["type"] = 'old_edit';
          list_convert_file.push(itemFile)
        }
        if (!this.$commonFuction.isEmpty(itemDataProduct.phone) && !this.$commonFuction.isEmpty(itemDataProduct.prefix_phone)) {
          itemDataProduct.phone_txt = itemDataProduct.prefix_phone+itemDataProduct.phone
        }

        itemDataProduct["list_file_product"] = list_convert_file;
        itemDataProduct["image_list"] = list_convert_file;
        console.log("itemDataProduct:",itemDataProduct)
        list_family_convert.push(itemDataProduct)
      }
      console.log("list_family_convertlist_family_convert:",list_family_convert)
      this.listDataProperty = list_convert;
      this.dataModelProperty = DataServices.getModel('property_user');
      this.componentKeyProperty++;

      this.listDataUserFamily = list_family_convert;
      this.loadTableUserFamily()
     /* this.dataModelUserFamily = DataServices.getModel('user_family');
      this.componentKeyUserFamily++;*/

      this.componentKey++;
    }else {
      //thêm mới
      this.obj_data = {
        prefix_phone:"+45",
       /* fullname: "Tuyen",
       
        email: "asdasdaskdjkask@gmail.com",
        prefix_phone: "+45",
        phone: "234434535",*/
        /*
        password: "123456",
        re_password: "123456",*/

        //default data

        active: true,
        ordinal: 1,
      };
      this.dataFamily = {
        prefix_phone:"+45",
      }
      this.dataModelUserFamily = DataServices.getModel('user_family');
      this.componentKeyUserFamily++;

      this.componentKey++;
    }
  },
  methods: {
    switchVisibility(event,type=null) {
      console.log("event:",event)
      console.log("typetype:",type)
      if (type=='re'){
        this.passwordReType = this.passwordReType === 'password' ? 'text' : 'password'
      }else {
        this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var list_data = []
      for (let i = 0; i < this.listDataUserFamily.length; i++) {
        var item_data = this.listDataUserFamily[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataUserFamily = list_data;
      this.loadTableUserFamily()
    },
    async loadTableUserFamily() {
      var stt = 0;
      var listDataUserFamily = this.listDataUserFamily;
      //this.mapServicePriceProduct = {};
      for (let i = 0; i < listDataUserFamily.length; i++) {
        stt++;
        //var itemData = listDataUserFamily[i];
        //var id = itemData?.id ?? null;
        listDataUserFamily[i].stt = stt;
        listDataUserFamily[i].index = i;
       // this.mapServicePriceProduct[id] = itemData;
      }
      this.listDataUserFamily = listDataUserFamily
      // console.log(" this.listDataUserFamily:", this.listDataUserFamily)
      this.dataModelUserFamily = DataServices.getModel('user_family');
      //this.dataModelProduct.processData(listDataUserFamily)
      this.componentKeyUserFamily++;
    },
    async validateDataUserFamily() {
      if (this.$commonFuction.isEmpty(this.dataFamily.name)) {
        alert('Please enter Fullname');
        return true;
      }
      if (!this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) || !this.$commonFuction.isEmpty(this.dataFamily.phone) ) {
        if (this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) || this.$commonFuction.isEmpty(this.dataFamily.phone)){
          alert('Please enter Phone number');
          return true;
        }
      }
      if (!this.$commonFuction.isEmpty(this.dataFamily.email)) {
        if( !(await this.$commonFuction.IsEmail(this.dataFamily.email)) ){
          alert("Email is not in correct format!");
          return true;
        }
      }

      if (this.list_file_product.length >0){
        if (this.list_file_product.length != 2){
          alert("Please choose 2 photos!");
          return true;
        }
      }
    },
    async saveDataUserFamily() {
      var that = this;
      if (await this.validateDataUserFamily()) {
        return
      }
      this.$commonFuction.is_loading(true);
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.dataFamily
      //delete this.dataFamilyDisplay
      console.log("paramsparams:",params)
      var id = params?.id ?? null;
      var itemObject = {
        // stt:1,
        list_id_file_delete_product:this.list_id_file_delete_product,
        //avatar:this.list_file_product[0].objectURL,
        list_file_product:this.list_file_product,
        image_list:this.list_file_product,
        name:params?.name ?? null,
        email:params?.email ?? null,
        personal_id:params?.personal_id ?? null,
        relationship:params?.relationship ?? null,
        phone:params?.phone ?? null,
        prefix_phone:params?.prefix_phone ?? null,
        phone_txt:null,
      }
      if (!this.$commonFuction.isEmpty(params.phone) && !this.$commonFuction.isEmpty(params.prefix_phone)) {
        itemObject.phone_txt = params.prefix_phone+params.phone
      }

      if (!this.$commonFuction.isEmpty(id)) {
        itemObject["id"] = id;
        this.listDataUserFamily[params?.index] = itemObject;
      }else {
        itemObject["id"] = moment().valueOf()+"";
        itemObject["is_new"] =1;//sp này do thêm mới chứ ko từ edit dat trong db
        this.listDataUserFamily.push(itemObject)
      }
      console.log("itemObjectitemObject:",itemObject)


      this.loadTableUserFamily()

      setTimeout(function () {
        //Gọi API refeshtoken
        that.dataFamilyDisplay=false;
        that.$commonFuction.is_loading(false);
        that.clearSaveUserFamily();
      }, 1000);

      /*params["list_file"] = this.list_file
      params["list_type"] = this.listDataUserFamily
      params["list_madatory"] = this.listDataMadatory
      params["list_lang"] = this.listLang
      params["list_id_file_delete"] = this.list_id_file_delete
      console.log('saveData', params)
      this.$emit('save', params)*/
    },
    clearSaveUserFamily() {
      this.dataFamily.id = null;
      this.dataFamily.name = '';
      this.dataFamily.relationship = '';
      this.dataFamily.prefix_phone = '';
      this.dataFamily.phone = '';
      this.dataFamily.email = '';
      this.dataFamily.personal_id = '';
      this.list_file_product = [];
      this.list_id_file_delete_product = [];
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      console.log("action.nameaction.name:",action.name)
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          //console.log("datadatadata:",data)
          /*this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111"+pageTransaction,payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }*//*
          this.index_edit =data.data.index
          this.obj_data.type_id =data.data.id
          this.obj_data.price_select =data.data.price_key
          this.key_type_id++;

          this.dataFamilyDisplay = true*/
          console.log("data.datadata.data:",data.data)

          this.list_file_product = data.data?.list_file_product ?? []
          this.list_id_file_delete_product = data.data?.list_id_file_delete_product ?? []
          /*if (this.list_file_product.length > 0){
            delete data.data.list_file_product;
            delete data.data.image_list;
          }
          console.log("data.datadata.data11:",data.data)
          this.dataFamily = this.$commonFuction.convertJsonObject(data.data)*/
         /* this.dataFamily = data.data
          if (this.list_file_product.length > 0){
            delete this.dataFamily.list_file_product;
            delete this.dataFamily.image_list;
          }*/
          this.dataFamily =  {};

          var key_not = ['list_file_product','image_list'];
          var data_edit =data.data
          for (let key in data_edit) {
           // if (data_edit.hasOwnProperty(key)) {
             // if (data_edit.hasOwnProperty(key)) { // Check if the property is directly on the object
             // console.log(key + ': ' + person[key]);
              if ( key_not.indexOf(key) == -1 ){
                this.dataFamily[key] = data_edit[key];
            //  }
            }
          }

          /*this.dataFamily.list_file_product =this.list_file_product;
          this.dataFamily.image_list =this.list_file_product;*/
          //this.dataFamily.list_id_file_delete_product =  this.list_id_file_delete_product;
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          break
        case 'delete':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          this.deleteId = data.data[action.key]
          console.log("this.deleteId:",this.deleteId)
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          console.log("this.componentDataFamily:",this.componentDataFamily)
          /*
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }*/
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      //if (this.role.add) {
        actions.header = {name: 'add', icon: 'plus', path: `list-${this.modelName}/add`};
      //}
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        //if (that.role.edit) {
        buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/`};
        //}
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        //if (that.role.delete) {
        buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        //}
        if (that.dataModelUserFamily.actions) {
          var modelaction = that.dataModelUserFamily.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    onFileClearProduct(item,index) {
      console.log('itemitem:',item)
      var type = item?.type ?? null
      if (type =='old_edit'){
        this.list_id_file_delete_product.push(item.id);
      }
      this.list_file_product.splice(index, 1);
    },
    async onFileSelectFileProduct(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:",files)
      console.log("files.length:",files.length)
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG']
        console.log("files.length1111111:",files.length)
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:",files.length)
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:",files[i].name)
          that.obj_data.filename =files[i].name;
          this.comFilename++;
        }
        var arrTemp = [], arrFiles = [];
        for (let file of files) {
          console.log('file.sizefile.sizefile.size:',file.size)
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:",file)
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:",arrTemp)
          //this.list_file_product = [];
          this.list_file_product = this.list_file_product.concat.apply(this.list_file_product, arrTemp);
        }
      }
      this.$refs.fileInputProduct.value = null;
    },
    onFileClear(item, index) {
      console.log('itemitem:', item)
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete.push(item.id);
      }
      this.list_file.splice(index, 1);
    },
    async onFileSelectFile(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:",files)
      console.log("files.length:",files.length)
      if(files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG']
        console.log("files.length1111111:",files.length)
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:",files.length)
          if (!acceptTags.includes(files[i].name.split('.').pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:",files[i].name)
          that.obj_data.filename =files[i].name;
          this.comFilename++;
        }
        var arrTemp = [], arrFiles = [];
        for (let file of files) {
          console.log('file.sizefile.sizefile.size:',file.size)
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:",file)
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:",arrTemp)
          this.list_file = [];
          this.list_file = this.list_file.concat.apply(this.list_file, arrTemp);
        }
      }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    updateMatrix(data) {
      console.log(data);
      this.dataBookingRound = [...data];
      // this.componentKey++;
    },
    async toCalendar() {
      this.$router.push(`/admin/list-booking?view=calendar&propery_id=${this.selProperty?.id}`);
    },
    async getListProperty(){
      var where_key = {
        deleted : {_eq : false},
        // booking: {id: {_is_null: true} },
      }
      var list = await this.$CoreService.getListProperty(where_key);
      this.listProperty =list.list;
      this.listPropertyAll = list.list;
    },
    async getListCountry() {
      var where_key = {
        deleted: { _eq: false },
        is_display_phone_admin: { _eq: true },
      }
      const response = await this.$CoreService.getListCountry(where_key);
      this.list_phone_code = response.list.map(country => ({
        label: `${country.phone_code}`,
        value: country.phone_code,
        id: country.id,
      }));
      if (this.model && this.model.prefix_phone_id) {
        const selectedCountry = this.list_phone_code.find(country => country.id === this.model.prefix_phone_id);
        if (selectedCountry) {
          this.obj_data.prefix_phone = selectedCountry.value;
        } 
      }
    },
    async SearchProperty(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          deleted : {_eq : false},
        };
        if (!this.$commonFuction.isEmpty(search)){
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListProperty(where_key);
        this.listProperty = list.list;
        //console.log("this.listProperty:",this.listProperty)
      }else{
        // cosnole.log("dasdasd")
        this.listProperty = this.listPropertyAll
      }
    },

    async getListDocsCate(){
      var where_key = {
        deleted : {_eq : false},
        // booking: {id: {_is_null: true} },
      }
      var list = await this.$CoreService.getListDocsCate(where_key);
      this.listDocsCate =list.list;
      this.listDocsCateAll = list.list;
    },

    async SearchDocsCate(search, loading){
      console.log(loading);
      if(search !== '' && search !== null){
        var where_key = {
          deleted : {_eq : false},
        };
        if (!this.$commonFuction.isEmpty(search)){
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListDocsCate(where_key);
        this.listDocsCate = list.list;
        //console.log("this.listProperty:",this.listProperty)
      }else{
        // cosnole.log("dasdasd")
        this.listDocsCate = this.listDocsCateAll
      }
    },

    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};


      let name_add = document.getElementById("name");
      if (this.$commonFuction.isEmpty(this.obj_data.fullname)){
        name_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      }else {
        name_add.setCustomValidity("");
      }

      let email_add = document.getElementById("email");
      if (this.$commonFuction.isEmpty(this.obj_data.email)){
        email_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      }else {
        // console.log("this.IsEmail(this.email)",this.IsEmail(this.email))
        if(await this.$commonFuction.IsEmail(this.obj_data.email)){
          var checkEmail = await this.checkEmail(this.obj_data.email);
          // console.log("checkEmail",checkEmail)
          if(checkEmail == true){
            email_add.setCustomValidity("Email already exists!");
          }else{
            email_add.setCustomValidity("");
          }
        }else{
          email_add.setCustomValidity("Email is not in correct format!");
        }
      }
      let phone_add = document.getElementById("phone");
      let prefix_phone = document.getElementById("prefix_phone");
      if (!this.$commonFuction.isEmpty(this.obj_data.phone) || !this.$commonFuction.isEmpty(this.obj_data.prefix_phone) ) {
        if (this.$commonFuction.isEmpty(this.obj_data.phone)){
          phone_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        }else {
          if(this.obj_data.phone.toString().length < 8){
            phone_add.setCustomValidity("Please enter a Phone number of at least 8 characters!");
          }else{
            if(this.obj_data.phone.toString().length > 15){
              phone_add.setCustomValidity("Please enter a Phone Number with at most 15 characters!");
            }else{
              //kiểm tra
              phone_add.setCustomValidity("");
            }
          }
        }

        if (this.$commonFuction.isEmpty(this.obj_data.prefix_phone)) {
          prefix_phone.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
        } else {
          prefix_phone.setCustomValidity("");
        }
      }else {
        phone_add.setCustomValidity("");
        prefix_phone.setCustomValidity("");
      }

      /*let available_from_add = document.getElementById("available_from");
      if (this.$commonFuction.isEmpty(this.obj_data.available_from)){
        available_from_add.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      }else {
        available_from_add.setCustomValidity("");
      }

      let available_to_add = document.getElementById("available_to");
      if (this.$commonFuction.isEmpty(this.obj_data.available_to)){
        available_to_add.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      }else {
        available_to_add.setCustomValidity("");
      }*/

      if (this.mode == 'add') {
        let password_add = document.getElementById("password");
        if (this.$commonFuction.isEmpty(this.obj_data.password)){
          password_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        }else {
          if(this.obj_data.password.length < 6){
            password_add.setCustomValidity("Please enter a password of at least 6 characters!");
          }else{
            //kiểm tra
            password_add.setCustomValidity("");
          }
        }
      }
      let Re_enter_password = document.getElementById("Re_enter_password");
      if (!this.$commonFuction.isEmpty(this.obj_data.password) || !this.$commonFuction.isEmpty(this.obj_data.re_password)){
        //check password khớp
        console.log('this.obj_data.password:',this.obj_data.password)
        console.log('this.obj_data.re_password:',this.obj_data.re_password)
        if (this.obj_data.password != this.obj_data.re_password){
          Re_enter_password.setCustomValidity("Passwords do not match!");
        }else {
          Re_enter_password.setCustomValidity("");
        }
      }

     /* let list_file_add = document.getElementById("list_file");
      if (this.$commonFuction.isEmpty(this.obj_data.filename)){
        list_file_add.setCustomValidity(this.$constants.MSG_TEXT.FILE_INVALID_MSG);
      }else {
        list_file_add.setCustomValidity("");
      }
*/
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()){
        console.log('test=====================');
        inpObj.reportValidity();
        return true;
      }
    },
    async checkEmail(email){
      // if(this.email !== null && this.email !== ''){
      var where = {
        email: {'_eq': email},
        deleted: {'_eq': false},
        // type: {'_eq' : 'user'}
      }
      if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
      var {data} = await this.$apollo.query({
        query: DataServices.getList('users', {"fields" : "id, email"}),
        variables: {
          where_key: where
        },
        fetchPolicy: "network-only"
      })
      // console.log(data)
      return data && data[Object.keys(data)].length > 0
      //}
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.obj_data
      //params["list_product"] = this.listDataProduct
      params["list_id_file_delete"] = this.list_id_file_delete
      params["list_file"] = this.list_file
      params["list_user_family"] = this.listDataUserFamily
      console.log('saveDatasaveDatasaveData', params)
      this.$emit('save', params)
    },
  },
}
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}
.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}
.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}
.p-multiselect-label-container{
  height: 40px;
}
.p-inputtext{
  margin:  0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}
label.p-col-fixed txt-right{
  margin-bottom: 0px!important;
}
div.p-card-field{
  padding: 0px!important;
}
.p-col-fixed {
  padding: 0px !important;
  margin:0px 0px 0px 9px !important;
}
.input_text{
  width: 760px!important;
  height: 48px!important;
}
.txt-right{
  font-weight: bold;
}

.multiselect{
  width: 760px!important;
}
.layout-main{
  background: #00000029;
}

.vs__clear{
  display: none;
}
.input_width{
  width: 760px!important;
  height: 48px!important;
}
#distance{
  width: 1px!important;
  height: 48px!important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}
.manager-title{
  font-size: 24px!important;
}
.input-dif{
  margin-left: 5px!important;
  border-top: 0px;
}
.p-inputgroup-addon{
  height: 48px ;
}
.txt-right{
  font-weight: bold;
}
.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}
label.p-col-fixed txt-right{
  margin-bottom: 0px!important;
}
div.p-card-field{
  padding: 0px!important;
}
.margin{
  margin-bottom: 12px!important;
}

.border_color{
  border: 1px solid #C8C8C8;
}
.text{
  font-weight: normal!important;
  margin-left: 15px!important;
}
.div_check{
  margin-top: 12px!important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width{
    width: 100%!important;
  }
  .div-button{
    padding: 8px!important;
  }
  #distance{
    text-align: left!important;
    padding: 6.8px;
    width: 100%!important;
  }
  .p-inputgroup-addon{
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width{
    width: 100%!important;
  }
  .div-button{
    padding: 8px!important;
  }
  .p-inputgroup-addon{
    margin-right: 12px;
  }
  #distance{
    text-align: left!important;
    padding: 6.8px;
  }
}
.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}
.cus-text{
  margin-left: 2px;
  margin-top: 4px;
}
.style-box-phone{
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;
  .p-dropdown{
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }
  .p-focus{
    border: 0px;
    box-shadow: none ;
  }
  .p-dropdown:focus{
    border: 0px;
    box-shadow: none;
  }
  input{
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }
  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}
.style_list_image {
  display: flex;
  flex-wrap: wrap; /* Cho phép các phần tử xuống dòng */
  gap: 10px; /* Khoảng cách giữa các phần tử */
  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;
    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }
    .button-clear{
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }

  }
}


.box-password-style{
  width: 100%;
  position: relative;
  .lg-icon-password {
    margin-top: -30px;
    display: block;
    position: absolute;
    right: 10px;
    padding: auto 5px;
    &:hover {
      cursor: pointer;
    }
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
  text-transform: uppercase;
}
</style>
